import { Component, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter, Input } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { DateQualifierService, DateRequirements } from 'src/app/model/api-services/qualifiers/date-qualifier.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';

import * as moment from 'moment-mini-ts';
import { Validator } from 'src/app/model/validator';

@Component({
  selector: 'app-datetime-input',
  templateUrl: './datetime-input.component.html',
  styleUrls: ['./datetime-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class DatetimeInputComponent
  extends InputComponent
  implements OnInit {

  public useDateOnly = false;
  public useTimeOnly = false;
  public useDateTime = false;
  public defaultValue: '' | 'NOW' = '';
  public minDate = '';
  public maxDate = '';
  private _dateValue: any;
  public debugging: boolean = false;
  @Input()
  public validator: Validator = null;

  public set currentValue(val: any) {
    if ([null, undefined, 0, ''].indexOf(val) > -1) {
      super.currentValue = '';
      this.cdr.detectChanges();
      return;
    }
    const castingType = (this.hasCasting === true) ? this.attribute.type : '';

    switch (castingType) {
      case 'text':
      case 'string':
        if (typeof val === 'string') {
          super.currentValue = val;
          if (this.attribute && this.attribute.casting && this.attribute.casting.entry) {
            if (this.attribute.casting.entry.type === 'time') {
              this.currentValue = DateQualifierService.FromString(val.toUpperCase(), this.attribute.casting.entry.format);
            }
          }
          this.validator.SetValue(this.attribute.name, val);
        } else {
          super.currentValue = DateQualifierService.ToString(val, this.casting.format);
          this.validator.SetValue(this.attribute.name, this.GetSuperValue() === '' ? null : this.GetSuperValue());
        }
        break;
      default:
        if (val instanceof Date) {
          super.currentValue = DateQualifierService.DateToDB(val);
          this.validator.SetValue(this.attribute.name, this.GetSuperValue() === '' ? null : this.GetSuperValue());
        } else {
          this.validator.SetValue(this.attribute.name, val);
          super.currentValue = val;
        }
    }
    if (this._dateValue !== this.validator.GetValue(this.attribute.name)) {
      this._dateValue = this.validator.GetValue(this.attribute.name);
    }
  }
  public get currentValue(): any {
    if (this.hasCasting && !!this.GetSuperValue()) {
      switch (this.attribute.type) {
        case 'text':
        case 'string':
          return this.GetSuperValue();
        default:
          return this.GetSuperValue() === '' ? null : this.GetSuperValue();
      }
    }

    switch (this.GetSuperValue()) {
      case '':
      case null:
      case undefined:
        return '';
      default:
        return this.GetSuperValue();
    }



  }
  public get currentDate(): Date {
    if (this.hasCasting && !!this.GetSuperValue()) {
      switch (this.attribute.type) {
        case 'text':
        case 'string':
          return DateQualifierService.FromString(this.currentValue, this.casting.format);
        default:
          return DateQualifierService.DBToDate(this.GetSuperValue());
      }
    } else {
      if (this.currentValue !== '') {
        return DateQualifierService.DBToDate(this.currentValue);
      }
    }
    return null;
  }

  public set dateValue(val: string) {


    if (['', undefined, null, 0].indexOf(val) > -1) {
      if (this.defaultValue === 'NOW') {
        const now = new Date();
        this.currentValue = now;
        this._dateValue = moment().format('YYYY-MM-DD');

        this.dateValueChange.emit(this._dateValue);

        this.cdr.detectChanges();
        return;
      }
      if (this._dateValue !== '') {
        this._dateValue = '';
        this.currentValue = '';
        this.cdr.detectChanges();
        return;
      }
      return;
    }
    this._dateValue = val;
    if (this.useDateOnly === true) {
      // const theDate = new Date(val);
      // theDate.setMinutes(theDate.getTimezoneOffset() + theDate.getMinutes());
      this.currentValue = val;
    } else if (this.useTimeOnly) {
      const newDate = new Date();
      const timeParts: Array<string> = val.split(':');
      newDate.setHours(Number(timeParts[0]));
      newDate.setMinutes(Number(timeParts[1]));
      newDate.setSeconds(0);
      newDate.setMilliseconds(0);
      this.currentValue = newDate;
    } else {
      this.currentValue = new Date(val);
    }
    this.dateValueChange.emit(this._dateValue);

    this.cdr.detectChanges();
  }
  public get dateValue(): string {
    return this._dateValue;
    /*if (['', undefined, null, 0].indexOf(this.currentValue) > -1) { return ''; }
    const dateStr: string = (this.currentValue as Date).toJSON();
    const dateTime: Array<string> = dateStr.split('T');
    if (this.useDateOnly === true) {
      return dateTime[0];
    }
    if (this.useDateTime === true) {
      return dateStr;
    }
    if (this.useTimeOnly === true) {
      if (dateTime.length > 1) {
        return dateTime[1];
      }
      return '';
    }*/
  }
  @Output()
  public dateValueChange = new EventEmitter<string>();
  constructor(private domNode: ElementRef, protected cdr: ChangeDetectorRef) {
    super(cdr);

  }

  SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
    const resetting = (layer && attribute && (layer.id === this.layer.id) && (this.attribute.id === attribute.id));

    super.SetAttribute(layer, attribute);
    let hadCasting = false;
    if (!!attribute.casting) {
      if (!!attribute.casting.entry && attribute.type !== 'date') {
        const requirements: DateRequirements = DateQualifierService.GetRequirements(attribute.casting.entry.format);

        this.useDateOnly = requirements.dateOnly;
        this.useDateTime = requirements.dateTime;
        this.useTimeOnly = requirements.timeOnly;
        if (!!attribute.casting.entry.range) {
          if (!!attribute.casting.entry.range.minDate) {
            if (this.useDateTime || this.useDateOnly) {
              this.maxDate = attribute.casting.entry.range.maxDate;
              this.minDate = attribute.casting.entry.range.minDate;
            }
            if (this.useDateTime === true) {
              // const utcOffset = +(new Date() as any).getUTCOffset();
              this.minDate = attribute.casting.entry.range.minDate + 'T00:00';
              this.maxDate = attribute.casting.entry.range.maxDate + 'T23:59'
            }
          }
        }
        if (attribute.casting.entry.dateDefault) {
          this.defaultValue = attribute.casting.entry.dateDefault;
        } else {
          this.defaultValue = '';
        }
        hadCasting = true;
      }
    }
    if (!hadCasting) {
      this.useDateOnly = true;
      this.useDateTime = false;
      this.useTimeOnly = false;
    }
    if (this.attribute.type !== 'date') {
      this.currentValue = attribute.type === 'date' ? this.currentValue : this.currentDate;
      this.dateValue = (!this.currentValue) ? '' : moment(this.currentDate).format('YYYY-MM-DD');
    } else {

    }

  }

  Reset() {
    super.Reset();
    this.useDateOnly = false;
    this.useTimeOnly = false;
    this.useDateTime = false;
  }
  SetDateFromInput(input: any) {
    this._dateValue = (input as HTMLInputElement).value;

    this.validator.SetValue(this.attribute.name, this.currentValue);
    super.currentValue = this._dateValue;

    this.Refresh();
  }

  private _ready;
  ngOnInit(): void {
    this._domNode = this.domNode;
    if (!this.initialized) {
      super.ngOnInit();
    }
    this._ready = true;
    this.Refresh();

  }
  Refresh() {
    if (!this._ready) {
      return;
    }
    this.cdr.detectChanges();
  }


}
